import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DeviceHardware, DeviceV3 } from '../../../../../backendsdk';
import { TrackedButton as Button } from '../../../../../components/TrackedComponents';
import VehicleSelector from '../components/VehicleSelector';

export interface SelectVehicleForAdjustProps {
    onSelect: (imei: string, hardware: DeviceHardware) => void;
    onBack: () => void;
    dashboardLink: React.ReactNode;
}

/**
 * Shown in adjust flow when no IMEI is in context (e.g. /tasks/adjust without a malfunction).
 * Lets the user select a vehicle (by VIN) to get the device IMEI and continue.
 */
const SelectVehicleForAdjust: React.FC<SelectVehicleForAdjustProps> = (props) => {
    const { t } = useTranslation();
    const [selectedDevice, setSelectedDevice] = useState<DeviceV3 | null>(null);

    const handleNext = () => {
        if (selectedDevice) {
            // DeviceV3 from useDevices does not expose hardware; use default for adjust
            props.onSelect(selectedDevice.device.device_id, DeviceHardware.ReachengR1);
        }
    };

    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" textAlign="center">
                {t('setup_tool.old_device.select_vehicle_header')}
            </Typography>
            <Box sx={{ width: '100%', mt: 2, flex: 1, minHeight: 0 }}>
                <VehicleSelector
                    value={selectedDevice}
                    onSelect={setSelectedDevice}
                    label={t('setup_tool.installation_params.license_plate')}
                />
            </Box>
            <Box sx={{ width: '100%', display: 'flex', mt: 2 }}>
                <Box sx={{ flex: 1, mr: 1 }}>
                    <Button id="btn-back" fullWidth variant="contained" color="primary" onClick={() => props.onBack()}>
                        {t('setup_tool.back')}
                    </Button>
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Button
                        id="btn-next"
                        fullWidth
                        variant="contained"
                        color="secondary"
                        disabled={!selectedDevice}
                        onClick={handleNext}
                    >
                        {t('setup_tool.next')}
                    </Button>
                </Box>
            </Box>
            {props.dashboardLink}
        </Box>
    );
};

export default SelectVehicleForAdjust;
